//* 화환 내역 페이지 전용 atom

import { atom } from 'recoil';

import { QueryStatus } from 'react-query';
import { recoilPersist } from 'recoil-persist';

import { FlowerStatDateType, FlowerStatResponse } from './flowerStat.interface';

const { persistAtom } = recoilPersist({
  key: 'flowerStat',
  storage: typeof window !== 'undefined' ? localStorage : undefined,
});

export const flowerStatStatusAtom = atom<QueryStatus>({
  key: 'flowerStatStatusAtom',
  default: 'idle',
});

export const flowerStatDataAtom = atom<FlowerStatResponse | null>({
  key: 'flowerStatDataAtom',
  default: null,
});

/** 판매일/발인일 기준 선택 (localStorage persist) */
export const flowerStatDateTypeAtom = atom<FlowerStatDateType>({
  key: 'flowerStatDateTypeAtom',
  default: 'purchasedAt',
  effects_UNSTABLE: [persistAtom],
});
